import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Registration from '../../../../components/Registration'
import { I18n } from 'react-i18next'
import {kpFetch} from "../../../../restClient"
import {toastr} from "react-redux-toastr"
import {europeanCountriesCodes, validateEmail} from "../../../KpModule/components/Form/formValidations";


const shelterNumberCheck = value =>
    value % 1 === 0 && value >= 0 && value <= 10
        ? undefined
        : 'Saisissez un nombre entier compris entre 0 et 10'

const required = value =>
    (typeof value === 'string') || _.isArray(value)
        ? value.length !== 0
            ? undefined
            : 'required'
        : (value !== undefined && value !== null)
            ? undefined
            : 'required'

const emailAddress = value =>
    value
        ? validateEmail(value)
            ? undefined
            : 'shouldBeAnEmail'
        : undefined

const getElementsById = options => options.reduce((acc, option) => {
    return {
        ...acc,
        [option.value]: option
    }},{})

const isValidPostalCode = (value) => {
    const postalCodePattern = /^\d{5}$/
    return postalCodePattern.test(value)
        ? undefined
        : 'Le code postal doit contenir exactement 5 chiffres'
}

const fieldLabels = {
    civility: 'Titre',
    firstname: 'Prénom',
    lastname: 'Nom',
    mail: 'Courriel',
    phone: 'Téléphone portable',
    organizationName: "Nom d'usage",
    organizationAddress: 'Adresse',
    organizationZipCode: 'Code postal',
    organizationCity: 'Ville',
    organizationCountry: 'Pays',
    code: 'N° SIREN',
    sheltersNumber: "Nombre d'établissements (refuges)",
    animalTypeGroup: 'Espèce(s) prise(s) en charge',
    publicUtilityRecognition: "Notre association est reconnue d'utilité publique",
    contactID: "Pièce d'identité Président(e) de l'association",
    situationNotice: 'Avis de situation au répertoire Sirene',
    updatedStatus: 'Statuts à jour',
    balanceSheetsAndIncomeStatements: 'Bilans et comptes de résultats des trois derniers exercices',
    officialStatement: "Déclaration officielle de création de l'association en Préfecture",
    CERFA: "CERFA et récépissé d'enregistrement de la dernière liste des dirigeants",
    lastGeneralMeeting: "Convocation et procès-verbal de la dernière Assemblée Générale",
}

const isValidSIREN = (value) => {
    const sirenPattern = /^\d{9}$/
    return sirenPattern.test(value)
        ? undefined
        : 'Le numéro SIREN doit contenir exactement 9 chiffres'
}

function validateEuropeanPhoneNumber(phoneNumber, values, props) {
    let countryCode = phoneNumber.substring(1, 3)
    let remainingNumber = phoneNumber.substring(3)

    if (countryCode !== "33") {
        return props.t('invalidCountryPrefix')
    }

    const { min, max } = europeanCountriesCodes[countryCode];
    if (remainingNumber.length < min || remainingNumber.length > max) {
        return props.t('invalidPhoneNumber')
    }

    return undefined
}


class UserRegistrationPage extends Component {
    constructor(props){
        super(props)
        this.state = {
            loading: false,
            error: true,
            errorMessage: true,
            success: false,
            functions: [],
            animalTypeGroups: [
                { value: 'domesticCarnivores', label: 'Carnivores domestiques' },
                { value: 'equids', label: 'Équidés' },
                { value: 'farmAnimals', label: 'Animaux de ferme' },
                { value: 'wildlife', label: 'Faune sauvage' }
            ],
            yesNo: [
                {value: 'yes', label: 'Oui'},
                {value: 'no', label: 'Non'}
            ],
            civilities: [
                { value: 'm', label: 'Monsieur' },
                { value: 'mme', label: 'Madame' }
            ],
            shelterTypes: [
                { value: 'pound', label: 'Fourrière' },
                { value: 'retirementHome', label: 'Maison de retraite' },
                { value: 'pension', label: 'Pension' },
                { value: 'hostFamily', label: "Famille d'accueil" },
                { value: 'shelter', label: 'Établissement' }
            ],
            activities: [
                { value: 'refuge', label: 'Établissement' },
                { value: 'hostFamily', label: "Famille d'accueil" },
                { value: 'pound', label: 'Fourrière' }
            ],
            validations: {
                civility: [required],
                firstname: [required],
                lastname: [required],
                mail: [required, emailAddress],
                phone: [required, validateEuropeanPhoneNumber],
                organizationName: [required],
                organizationAddress: [required],
                organizationZipCode: [required, isValidPostalCode],
                organizationCity: [required],
                organizationCountry: [required],
                code: [required, isValidSIREN],
                sheltersNumber: [required, shelterNumberCheck],
                animalTypeGroup: [required],
                publicUtilityRecognition: [required],
                contactID: [required],
                situationNotice: [required],
                updatedStatus: [required],
                balanceSheetsAndIncomeStatements: [required],
                officialStatement: [required],
                CERFA: [required],
                lastGeneralMeeting: [required]
            },
            validationErrors: {},
            formDirty: false,
        }
        this.validateField = this.validateField.bind(this)
        this.validateForm = this.validateForm.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleResponse = this.handleResponse.bind(this)
    }
    componentDidMount() {
        kpFetch('GET', `/userRegistrationDataLists`, "", {})
            .then(
                ({ ok, json, message }) => {
                    if (!ok || !json.length) {
                        console.log('response for fetching data for registration form not OK')
                    }
                    this.setState({
                        functions: json.functions.map(o => ({value: o._id.toString(), label: o.name})),
                        animalTypes: json.animalTypes.map(o => ({value: o._id.toString(), label: o.name}))
                    })
                }
            )
            .catch(error =>
                console.log('error fetching data for registration form', error)
            )
    }

    handleResponse = response => {
        if(!response.error) {
            this.setState({
                loading: false,
                success: true,
            })
            setTimeout(() => window.open("https://www.defensedelanimal.fr", "_self"), 15000)
        } else {
            this.setState({
                loading: false,
                error: true,
                errorMessage: response.error.message
            })
        }
    }
    handleSubmit = data => {
        const {t} = this.props
        const validationErrors = this.validateForm(data)

        const errorFieldsKeys = Object.keys(validationErrors)

        const formDirty = !!errorFieldsKeys.length

        if(formDirty) {

            const firstErrorKey = errorFieldsKeys[0]
            const fieldLabel = fieldLabels[firstErrorKey] || firstErrorKey
            toastr.error(
                t('validationError'),
                fieldLabel + ' : ' + t(validationErrors[firstErrorKey])
            )
            this.setState({formDirty, validationErrors})
        } else {
            this.setState({
                loading: true,
                formDirty: false,
                validationErrors: {}
            })
            this.props.register(data)
                .then( response => this.handleResponse(response))
        }
    }

    validateField(data) {
        const validationErrors = this.validateForm(data)

        const noErrorFields = Object.keys(data).filter(key => !validationErrors[key])
        const filteredValidationsObject = _.omit(this.state.validationErrors, noErrorFields)

        const combinedValidationErrors = {
            ...filteredValidationsObject,
            ...validationErrors
        }

        this.setState({
            formDirty: !!Object.keys(combinedValidationErrors).length,
            validationErrors: combinedValidationErrors
        })
    }

    validateForm(data) {
        return Object.keys(data).reduce((acc, key) => {
            const validations = this.state.validations[key]
            if(!validations || validations.length === 0) return acc
            let error
            const hasError = validations.some(validation => {
                const result = validation(data[key], data, this.props)
                if(result) {
                    error = result
                    return true
                }
                return false
            })
            return hasError
                ? {...acc, [key]: error}
                : acc
        }, {})
    }

    render() {
        const {yesNo, animalTypeGroups, civilities, functions, activities, animalTypes, shelterTypes, loading, success, validationErrors} = this.state

        const yesNoById = getElementsById(yesNo)
        const animalTypeGroupsById = getElementsById(animalTypeGroups)
        const civilitiesById = getElementsById(civilities)
        const activitiesById = getElementsById(activities)
        const functionsById = getElementsById(functions)
        const shelterTypesById = getElementsById(shelterTypes)

        return (
            <I18n
                key={'C'}
                ns={['C', 'platform']}
            >
                {
                    t =>
                        <Registration
                            handleSubmit={this.handleSubmit}
                            validateField={this.validateField}
                            success={success}
                            loading={loading}
                            yesNo={yesNo}
                            yesNoById={yesNoById}
                            civilities={civilities}
                            civilitiesById={civilitiesById}
                            animalTypeGroups={animalTypeGroups}
                            animalTypeGroupsById={animalTypeGroupsById}
                            functions={functions}
                            activities={activities}
                            activitiesById={activitiesById}
                            functionsById={functionsById}
                            animalTypes={animalTypes}
                            shelterTypes={shelterTypes}
                            shelterTypesById={shelterTypesById}
                            validationErrors={validationErrors}
                            t={t}
                        />
                }
            </I18n>
        )

    }
}

UserRegistrationPage.propTypes = {
    register: PropTypes.func.isRequired,
}

export default UserRegistrationPage
